import React, { useState, useEffect, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useRefreshToken from "../../hooks/useRefreshToken";

import { Link } from "react-router-dom";

const UserList = () => {
  const refresh = useRefreshToken();
  const axiosPrivate = useAxiosPrivate();

  const [users, setUsers] = useState();

  const getUsers = useCallback(async () => {
    try {
      const response = await axiosPrivate.get("/auth/users");
      setUsers(response.data.users);
    } catch (error) {
      console.log(error.message);
    }
  }, []);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const clickHandler = () => {
    refresh().then((res) => {});
  };

  const logoutHandler = () => {
    localStorage.clear();
  };

  return (
    <div>
      <h1>User List</h1>
      <Link onClick={logoutHandler} to="/">
        Logout
      </Link>

      <p>
        <Link to="/admin">Admin ? Click Here</Link>
      </p>

      <p>
        <Link to="/supervisor">Supervisor ? Click Here</Link>
      </p>

      <p>
        <Link to="/operator">Operator ? Click Here</Link>
      </p>

      <p>
        <Link to="/mis">Mis Click Here</Link>
      </p>

      <button onClick={clickHandler}>Get new token</button>

      {users &&
        users.map((user) => {
          return (
            <div key={Math.random()}>
              <h3>{user.username}</h3>
              <p>{user.role}</p>
            </div>
          );
        })}
    </div>
  );
};

export default UserList;
